import React, { useEffect, useState } from "react";
import analyticsApi from "../../analyticsApi.js";
import tampuuriWindowObject from "../../tampuuriWindowObject.js";
import CardTop from "./CardTop.jsx";
import CardImageAndBody from "./CardImageAndBody.jsx";
import CardBottom from "./CardBottom.jsx";
import accessibility from "../../accessibility.js";

const Card = (props) => {
  const { card, className = "", svgObjects } = props;
  const [classes, setClasses] = useState(className);
  const [state, setState] = useState({});
  const [favouriteClassname, setFavouriteClassName] = useState("");

  const { translate, translatei18nDB, constructApartmentName } =
    tampuuriWindowObject();

  const [href, setHref] = useState(null);
  const { announceMessage, globalAccessibilitySpeakerId } = accessibility();
  const { generateAnalyticsAddToCart } = analyticsApi();

  const isRoomOrApartment = (card) => {
    if (card?.type == "Huone" || card?.type == "Huoneisto") {
      return true;
    }
    return false;
  };

  //Just to handle this also in the forms!
  if (card?.type === "Huone") {
    card.apartment_category = translatei18nDB(card.apartment_category);
  }

  const localStorageFavouriteObject = isRoomOrApartment(card)
    ? window.hoasFavourites.createApartmentObject(card)
    : window.hoasFavourites.createCostUnitObject(card);

  useEffect(() => {
    setState({ loading: true });
    const url =
      window.location.origin + window.location.pathname + card.permalink;
    setHref(url);
    constructFavouriteClassName();
    setState({ loading: false });
  }, [card]);

  const checkRender = (card) => {
    if (card?.quarter_of_town && card?.city) {
      return true;
    }
    return false;
  };

  const handleFavoriteClick = (event) => {
    event.preventDefault();

    const isFound = window.hoasFavourites.hasDataByKey(
      localStorageFavouriteObject.type,
      localStorageFavouriteObject,
    );

    if (isFound) {
      window.hoasFavourites.removeDataByKey(
        localStorageFavouriteObject.type,
        localStorageFavouriteObject,
      );

      const message =
        constructApartmentName(localStorageFavouriteObject.address) +
        " " +
        translate("Poistettu suosikeista");
      announceMessage(globalAccessibilitySpeakerId, message);
      //Remove the active class
      setFavouriteClassName("");
      return;
    }
    // Not found from localstorage
    window.hoasFavourites.addDataByKey(
      localStorageFavouriteObject.type,
      localStorageFavouriteObject,
    );

    localStorageFavouriteObject.pll_current_language = translate(
      "pll_current_language",
    );
    generateAnalyticsAddToCart(localStorageFavouriteObject);

    setFavouriteClassName("active");
    const message =
      constructApartmentName(localStorageFavouriteObject.address) +
      " " +
      translate("Lisätty suosikiksi");
    announceMessage(globalAccessibilitySpeakerId, message);
  };

  const constructFavouriteClassName = () => {
    //For the first render and for re-renders
    const isFound = window.hoasFavourites.hasDataByKey(
      localStorageFavouriteObject.type,
      localStorageFavouriteObject,
    );

    if (isFound) {
      setFavouriteClassName("active");
    }
  };

  return (
    <>
      {!state?.loading && checkRender(card) && (
        <div className={classes}>
          <article aria-label={card?.name}>
            <CardTop
              card={card}
              svgObjects={svgObjects}
              isRoomOrApartment={isRoomOrApartment}
              handleFavoriteClick={handleFavoriteClick}
              favouriteClassname={favouriteClassname}
              localStorageFavouriteObject={localStorageFavouriteObject}
            />

            <CardImageAndBody
              card={card}
              href={href}
              isRoomOrApartment={isRoomOrApartment}
            />

            <CardBottom
              card={card}
              href={href}
              handleFavoriteClick={handleFavoriteClick}
              favouriteClassname={favouriteClassname}
              isRoomOrApartment={isRoomOrApartment}
              svgObjects={svgObjects}
              localStorageFavouriteObject={localStorageFavouriteObject}
            />
          </article>
        </div>
      )}
    </>
  );
};

export default Card;
